import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import SliderPage from './SliderPage';
import DyPage from './DyPage';

var ColorPage = function ColorPage(_ref) {
  var addVariantToCart = _ref.addVariantToCart,
      checkout = _ref.checkout,
      colorTemplate = _ref.colorTemplate,
      colorSliders = _ref.colorSliders;
  return React.createElement(
    Fragment,
    null,
    colorSliders && colorSliders.map(function (slider, ind) {
      return React.createElement(DyPage, {
        key: slider,
        addVariantToCart: addVariantToCart,
        checkout: checkout,
        dySlug: 'color-slider-' + colorTemplate + '-' + (ind + 1),
        sliderId: slider
      });
    })
  );
};

ColorPage.propTypes = {
  addVariantToCart: PropTypes.func.isRequired,
  checkout: PropTypes.object.isRequired,
  colorTemplate: PropTypes.string,
  colorSliders: PropTypes.array
};

export default ColorPage;